import { Routes } from "@angular/router";
import { actionsGuard } from "../shared/guards/actions.guard";
import { TurnListComponent } from "./turn-list/turn-list.component";
import { TurnPerDayComponent } from "./turn-per-day/turn-per-day.component";
import { TurnStatistucsListComponent } from "./turn-statistucs-list/turn-statistucs-list.component";
import { TurnsStatisticsComponent } from "./turns-statistics/turns-statistics.component";

export const turnRoutes: Routes = [
  { path: '', redirectTo: 'list', pathMatch: 'full' },
  { path: 'list', component: TurnStatistucsListComponent, canActivate: [actionsGuard] },
  { path: 'perday', component: TurnPerDayComponent },
  { path: 'statistics', component: TurnsStatisticsComponent }
  // { path: 'create', component: PermissionsCreateComponent, canActivate: [actionsGuard] },
  // { path: 'edit/:id', component: PermissionsEditComponent, canActivate: [actionsGuard] },
  // { path: 'delete/:id', component: PermissionsDeleteComponent, canActivate: [actionsGuard] },
  // { path: 'details/:id', component: PermissionsDetailsComponent, canActivate: [actionsGuard] },
]
